import { EntryPick } from "./EntryPick";

export function SubmittedEntry(props) {

    if (!props.games || props.games.length === 0 || !props.entry) {
        return <></>
    }

    const findGame = (id) => {
        for (let i = 0; i < props.games.length; i++) {
            if (props.games[i].id === id) {
                return props.games[i];
            }
        }
        return null;
    }

    return (
        <tr className={props.entry.status === 'LOSS' ? 'strikeout' : ''}>
            <td className="align-middle">{props.user ? `${props.user.name}-${props.entry.name.substring(6)}` : props.entry.name}</td>
            {props.entry.picks.map((p) => { return { pick: p, game: findGame(p.game_id) } }).sort((p1, p2) => {
                if (p1.game && p2.game) {
                    return Date.parse(p1.game.start_time) - Date.parse(p2.game.start_time);
                } else {
                    return 0;
                }
            }).map((p) => {
                return (
                    <EntryPick key={`${p.pick.entry_id}-${p.pick.game_id}`} entry={props.entry} game={p.game} pick={p.pick} />
                );
            })}
        </tr>
    );
}